import {checkError, closeAlert} from "./commonsActions";
import {getLatestClientUpdate, saveNewVersion} from "../helpers/clientUpdateService";

export const SAVE_NEW_CLIENT_VERSION_BEGIN = 'SAVE_NEW_CLIENT_VERSION_BEGIN';
export const SAVE_NEW_CLIENT_VERSION_SUCCESS = 'SAVE_NEW_CLIENT_VERSION_SUCCESS';
export const SAVE_NEW_CLIENT_VERSION_ERROR = 'SAVE_NEW_CLIENT_VERSION_ERROR';

export const FETCH_LATEST_CLIENT_VERSION_BEGIN = 'FETCH_LATEST_CLIENT_VERSION_BEGIN';
export const FETCH_LATEST_CLIENT_VERSION_SUCCESS = 'FETCH_LATEST_CLIENT_VERSION_SUCCESS';

export const fetchLatestClientUpdate = () => dispatch => {
    dispatch({type: FETCH_LATEST_CLIENT_VERSION_BEGIN});
    return getLatestClientUpdate()
        .then(res => {
            dispatch({
                type: FETCH_LATEST_CLIENT_VERSION_SUCCESS,
                payload: {latestClientUpdate: res.data}
            });
            return res
        }, error => {
            dispatch(checkError(error));
            setTimeout(() => {
                dispatch(closeAlert());
            }, 2000);
        })
};

export const saveNewClientVersion = query => dispatch => {
    dispatch({type: SAVE_NEW_CLIENT_VERSION_BEGIN});
    return saveNewVersion(query).then(res => {
        dispatch({
            type: SAVE_NEW_CLIENT_VERSION_SUCCESS,
            payload: {savedNewClientUpdate: res.data}
        });
        return res;
    }, error => {
        dispatch({type: SAVE_NEW_CLIENT_VERSION_ERROR});
        throw error;
    })
};




// WEBPACK FOOTER //
// ./src/actions/clientUpdateActions.js